import { resolveDevMarket } from './devMarket';
import { isCzechMarket } from './isCzechMarket';

export function isSlovakMarket() {
  if (isCzechMarket()) {
    return false;
  }

  const host = window.location.host.toLowerCase();
  if (host.endsWith('.sk')) {
    return true;
  }

  return resolveDevMarket() === 'sk';
}
